import { Component, Input, OnInit } from '@angular/core';


@Component({
    selector: 'app-leveling-side-grid',
    templateUrl: './leveling-side-grid.component.html',
    styleUrls: ['./leveling-side-grid.component.scss'],
    standalone: false
})
export class LevelingSideGridComponent implements OnInit {
	@Input() public orientation: "vertical" | "horizontal" = "horizontal";

	// @Input() public pageSize: number = 10;

	@Input() public columns: { columnName: string; caption: string }[] = [];
	@Input() public data: any[] = [];

	constructor() { }

	ngOnInit() {
	}
}
